import { ZuiDialogBox } from '@zeiss/zui-react'

export const DialogBox = ({ children, onClose, onAccept, onCancel, ...props }) => {
    return (
        <ZuiDialogBox
            onDialogBoxClosed={onClose}
            onDialogBoxAccepted={onAccept}
            onDialogBoxCancelled={onCancel}
            {...props}
        >
            {children}
        </ZuiDialogBox>
    )
}
